<template>
    <v-navigation-drawer v-model="drawer" app dark fixed permanent :mini-variant.sync="mini" expand-on-hover
        color="sidebar" class="redesign-sidebar">
        <v-list nav class="py-2">
            <v-list-item class="mb-6">
                <v-list-item-title class="p-relative logo-container">
                    <img class="logo-img logo-mini" :class="{ 'logo-visible': mini }"
                        :src="require('@/assets/img/brand_mark.png')" alt="" />
                    <img class="logo-img logo-full" :class="{ 'logo-visible': !mini }"
                        :src="require('@/assets/img/logo_sidebar.png')" alt="" />
                </v-list-item-title>
            </v-list-item>
            <v-list-item v-for="(item, index) in itemsNoProfile" :key="index" :ref="item.ref" :to="item.link || null"
                exact link :class="['nav-item', { 'v-list-item--active': item.ref === navActiveRef }]">
                <v-list-item-icon>
                    <v-badge v-if="item.count && item.count > 0" color="error" :content="item.count" overlap
                        offset-x="20" offset-y="0">
                        <v-icon size="20">{{ item.icon }}</v-icon>
                    </v-badge>
                    <v-icon v-else size="20">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="list-title">{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>

        <template v-slot:append>

            <v-list nav class="py-2">
                <v-list-item ref="profile" :to="profileRoute" link class="nav-item">
                    <v-list-item-icon>
                        <v-icon size="20">$account_circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">{{ $t('common.profile') }}</v-list-item-title>
                </v-list-item>

                <v-list-item link class="nav-item" @click="logout">
                    <v-list-item-icon>
                        <v-icon size="20">$logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title class="list-title">{{ $t('entrance.logout') }}</v-list-item-title>
                </v-list-item>

                <v-list-item v-if="account" class="account-item">
                    <v-list-item-icon>
                        <div class="sidebar-avatar">{{ initials }}</div>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title class="sidebar-account-name">{{ account.name }}</v-list-item-title>
                        <v-list-item-subtitle class="sidebar-account-email">{{ account.email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

        </template>

    </v-navigation-drawer>
</template>

<script>
import { links } from "@/mixins/baseGlobalMixin";
import { getInitials } from '@/utils/Common'

import { logout } from '@/utils/Session'

export default {
    name: "NavigationDrawer",
    mixins: [links],
    data() {
        return {
            drawer: false,
            mini: true,
        }
    },
    computed: {
        itemsNoProfile(vm = this) {
            return vm.items.filter(item => item.ref !== 'profile')
        },
        initials(vm = this) {
            return getInitials(vm.account?.name)
        },
        profileRoute(vm = this) {
            switch (vm.account?.accountType) {
                case 'student':
                    return { name: 'student.profile' }
                case 'coach':
                case 'coach_company':
                    return { name: 'coach.profile' }
                case 'company':
                    return { name: 'company.profile' }
            }
        }
    },
    methods: {
        async logout() {
            await logout(this.$router)
        },
        setMini() {
            const vm = this
            vm.mini = !vm.mini
        }
    }
}
</script>

<style scoped>
.redesign-sidebar {
    border-right: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.redesign-sidebar.redesign-sidebar {
    transition-duration: 0.16s !important;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1) !important;
    will-change: width;
}

.redesign-sidebar ::v-deep .v-navigation-drawer__content {
    contain: layout;
    transform: translateZ(0);
}

.redesign-sidebar ::v-deep .v-list-item__content,
.redesign-sidebar ::v-deep .v-list-item__title,
.redesign-sidebar ::v-deep .v-list-item__icon {
    transition-duration: 0.16s !important;
    transition-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1) !important;
}

.logo-container {
    position: relative;
    height: 34px;
}

.logo-img {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto 0;
    opacity: 0;
    transition: opacity 0.16s ease;
    pointer-events: none;
}

.logo-img.logo-visible {
    opacity: 1;
}

.logo-mini {
    height: 30px;
    width: auto;
}

.logo-full {
    height: 30px;
    width: auto;
}

.list-title {
    font-weight: 500;
    font-size: 13px;
    line-height: 17px;
}

.nav-item {
    border-radius: 8px;
    margin-bottom: 2px;
    min-height: 40px;
    color: #3A4558;
}

.nav-item ::v-deep .v-list-item__icon {
    margin-top: 9px;
    margin-bottom: 9px;
    margin-right: 10px;
}

.nav-item ::v-deep .v-icon {
    color: #3A4558;
}

.nav-item:hover {
    background: #1A1E27;
}

.nav-item:hover,
.nav-item:hover ::v-deep .v-icon {
    color: #8892A4;
}

.redesign-sidebar ::v-deep .v-list-item--active {
    color: #F0F2F5 !important;
}

.redesign-sidebar ::v-deep .v-list-item--active .v-icon {
    color: #F0F2F5 !important;
}

.redesign-sidebar ::v-deep .v-list-item--active::before {
    opacity: 0;
}

.redesign-sidebar ::v-deep .v-list-item--active::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 22px;
    background: var(--brand-gradient);
    border-radius: 0 3px 3px 0;
}

.account-item {
    min-height: 48px;
    height: 48px;
    margin-top: 4px;
}

.account-item ::v-deep .v-list-item__icon {
    margin: 0 10px 0 0;
    min-width: 28px;
    height: 28px;
    align-self: center;
}

.account-item ::v-deep .v-list-item__content {
    padding: 0;
    align-self: center;
}

.sidebar-avatar {
    flex: 0 0 28px;
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 50%;
    background: var(--brand-gradient);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    color: #0C0E12;
}

.sidebar-account-name {
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    color: #F0F2F5;
}

.sidebar-account-email {
    font-size: 11px;
    line-height: 15px;
    color: #8892A4 !important;
}

::v-deep ::-webkit-scrollbar {
    width: 4px;
}

::v-deep ::-webkit-scrollbar-thumb {
    background: #2A3450;
    border-radius: 50px;
}

::v-deep ::-webkit-scrollbar-track {
    background: transparent;
}
</style>
